import { useEffect, useState } from "react";

import { useGetSubtitles } from "@hooks/useGetSubtitles";
import { languages } from "../../constants";

interface CaptionTrackProps {
  assetUrl: string;
  language: string;
}

export default function CaptionTrack({
  assetUrl,
  language,
}: Readonly<CaptionTrackProps>) {
  const { data: vttContent } = useGetSubtitles(assetUrl);
  const [trackSrc, setTrackSrc] = useState<string>();

  useEffect(() => {
    if (!vttContent) {
      setTrackSrc(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(
      new Blob([vttContent], { type: "text/vtt" })
    );
    setTrackSrc(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [vttContent]);

  if (!trackSrc) return null;

  return (
    <track
      kind="captions"
      src={trackSrc}
      srcLang={language}
      label={languages[language as keyof typeof languages] ?? language}
    />
  );
}
